// extracted by mini-css-extract-plugin
export default {"aboutContainer":"About_aboutContainer__uH1KU","aboutBanner":"About_aboutBanner__s+Ng3","overlay":"About_overlay__a9Nbf","image":"About_image__RIve+"};